(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    function scInit() {
    // Helper: Cookies
    function setCookie(name, value, days) {
      let expires = '';
      if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }
    function getCookie(name) {
      let nameEQ = name + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    // Detect Meta in-app browsers (Instagram, Facebook, Messenger, Threads).
    // These WebViews have known issues with IntersectionObserver re-evaluation
    // after visibility changes and with the `loading="lazy"` attribute on images
    // inside initially hidden containers — which prevents color cards from ever
    // hydrating their <img> tags.
    const scUA = (navigator.userAgent || '') + ' ' + (navigator.vendor || '');
    const scIsInAppBrowser = /FBAN|FBAV|FB_IAB|FBIOS|Instagram|Threads|MessengerLiteForiOS|Line\/|TikTok|Snapchat/i.test(scUA);

    let scModalBodyScrollY = 0;
    let scModalBodyLocked = false;

    /** Lock document scroll while #sc-color-modal or #sc-nail-preview-modal is open. */
    function scSyncModalBodyScroll() {
      const colorModal = document.getElementById('sc-color-modal');
      const nailPreview = document.getElementById('sc-nail-preview-modal');
      const anyOpen =
        (colorModal && colorModal.getAttribute('aria-hidden') === 'false') ||
        (nailPreview && nailPreview.getAttribute('aria-hidden') === 'false');

      if (anyOpen && !scModalBodyLocked) {
        scModalBodyScrollY = window.scrollY;
        document.documentElement.classList.add('sc-modal-open');
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + scModalBodyScrollY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        scModalBodyLocked = true;
      } else if (!anyOpen && scModalBodyLocked) {
        document.documentElement.classList.remove('sc-modal-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, scModalBodyScrollY);
        scModalBodyLocked = false;
      }
    }

    function scGetColorModal() {
      return document.getElementById('sc-color-modal');
    }
    function scQsMainGridSlots() {
      return document.querySelectorAll('.sc-color-selection-wrapper .sc-color-slot:not([data-bonus])');
    }
    function scQsBonusSlots() {
      return Array.from(
        document.querySelectorAll('.sc-color-selection-wrapper .sc-color-slot--bonus')
      ).sort(
        (a, b) =>
          parseInt(a.getAttribute('data-bonus-index') || '0', 10) -
          parseInt(b.getAttribute('data-bonus-index') || '0', 10)
      );
    }
    function scQsModalThumbSlots() {
      return document.querySelectorAll('#sc-modal-thumbnails .sc-thumb-slot');
    }
    function scGetProductGrid() {
      const m = scGetColorModal();
      return m ? m.querySelector('.sc-product-grid') : null;
    }
    function scGetSelectionWrapper() {
      return document.querySelector('.sc-color-selection-wrapper');
    }
    /** Required set colors (e.g. 4 or 6). */
    function scGetBaseColorsCap() {
      return parseInt(
        scGetSelectionWrapper()?.getAttribute('data-total-colors') ||
          document.getElementById('sc-add-to-cart-button')?.getAttribute('data-total') ||
          6,
        10
      );
    }
    function scIsBonusEnabled() {
      return scGetSelectionWrapper()?.getAttribute('data-bonus-enabled') === 'true';
    }
    function scGetBonusDiscountPercent() {
      return parseInt(scGetSelectionWrapper()?.getAttribute('data-bonus-discount') || '20', 10) || 20;
    }
    function scGetBonusDiscountCode() {
      return (scGetSelectionWrapper()?.getAttribute('data-bonus-discount-code') || '').trim();
    }
    function scShowSlotPrices() {
      return scGetSelectionWrapper()?.getAttribute('data-show-slot-prices') === 'true';
    }

    /** Format cents using theme money format (fallback: EUR de-DE). */
    function scFormatMoney(cents) {
      cents = Number(cents) || 0;
      const format =
        (window.themeVariables?.settings?.currencyCodeEnabled
          ? window.themeVariables?.settings?.moneyWithCurrencyFormat
          : window.themeVariables?.settings?.moneyFormat) || '';
      if (!format) {
        return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
      }
      const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      const token = match ? match[1] : 'amount';
      const amount = cents / 100;
      let value;
      switch (token) {
        case 'amount_no_decimals':
          value = Math.round(amount).toString();
          break;
        case 'amount_with_comma_separator':
          value = amount.toFixed(2).replace('.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = Math.round(amount).toString();
          break;
        case 'amount_with_space_separator':
          value = amount.toFixed(2);
          break;
        default:
          value = amount.toFixed(2);
      }
      return format.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    function scGetSetPriceCents() {
      const btn = document.getElementById('sc-add-to-cart-button');
      return parseInt(btn?.getAttribute('data-price') || '0', 10) || 0;
    }
    function scGetSetCompareCents() {
      const btn = document.getElementById('sc-add-to-cart-button');
      const compare = parseInt(btn?.getAttribute('data-compare-at') || '0', 10) || 0;
      const price = scGetSetPriceCents();
      return compare > price ? compare : price;
    }

    /**
     * Bonus discount % from theme setting (data-bonus-discount).
     * Used for badge text, ATC bonus pricing, and cart properties.
     */
    function scGetActiveBonusDiscountPercent() {
      return scGetBonusDiscountPercent();
    }

    /** Discounted unit price for a bonus color (cents). */
    function scBonusUnitPriceCents(prod) {
      const price = parseInt(prod?.price, 10) || 0;
      const pct = scGetActiveBonusDiscountPercent();
      return Math.round((price * (100 - pct)) / 100);
    }

    function scBonusUnitCompareCents(prod) {
      const price = parseInt(prod?.price, 10) || 0;
      const compare = parseInt(prod?.compare_at_price, 10) || 0;
      return compare > price ? compare : price;
    }

    /** Totals for set + optional bonus colors (cents). */
    function scGetCartTotals(bonusProducts) {
      const setPrice = scGetSetPriceCents();
      const setCompare = scGetSetCompareCents();
      const list = bonusProducts || [];
      let totalPrice = setPrice;
      let totalCompare = setCompare;
      list.forEach((prod) => {
        totalPrice += scBonusUnitPriceCents(prod);
        totalCompare += scBonusUnitCompareCents(prod);
      });
      return { totalPrice, totalCompare };
    }

    /** Build ATC ready HTML for current set + optional bonus colors. */
    function scBuildReadyAtcHtml(bonusProducts) {
      const btn = document.getElementById('sc-add-to-cart-button');
      const readyText = btn?.getAttribute('data-ready-text') || 'In den Warenkorb';
      const { totalPrice, totalCompare } = scGetCartTotals(bonusProducts);
      let html = readyText + ' | ' + scFormatMoney(totalPrice);
      if (totalCompare > totalPrice) {
        html += ' <s>' + scFormatMoney(totalCompare) + '</s>';
      }
      return html;
    }

    /** Effective overall discount % for set + selected bonus colors. */
    function scGetEffectiveDiscountPercent(bonusProducts) {
      const { totalPrice, totalCompare } = scGetCartTotals(bonusProducts);
      if (totalCompare <= totalPrice || totalCompare <= 0) return 0;
      return Math.round(((totalCompare - totalPrice) / totalCompare) * 100);
    }

    /** Sync PDP price list (.product-meta__price-list-container) to set + bonus totals. */
    function scUpdateProductMetaPrice(bonusProducts) {
      const priceLists = document.querySelectorAll('.product-meta__price-list-container .price-list');
      if (!priceLists.length) return;

      const { totalPrice, totalCompare } = scGetCartTotals(bonusProducts);
      const hasCompare = totalCompare > totalPrice;
      const saleLabel = window.themeVariables?.strings?.salePrice || 'Sale price';
      const regularLabel = window.themeVariables?.strings?.regularPrice || 'Regular price';
      const priceHtml =
        '<span class="visually-hidden">' + saleLabel + '</span>' + scFormatMoney(totalPrice);
      const compareHtml =
        '<span class="visually-hidden">' + regularLabel + '</span>' + scFormatMoney(totalCompare);

      priceLists.forEach((priceList) => {
        // Keep unit-price block; replace only main price / compare spans
        const unitPriceEl = priceList.querySelector('.unit-price-measurement')?.closest('.price');
        Array.from(priceList.children).forEach((el) => {
          if (!el.classList || !el.classList.contains('price')) return;
          if (unitPriceEl && el === unitPriceEl) return;
          el.remove();
        });

        const priceEl = document.createElement('span');
        priceEl.className = hasCompare ? 'price price--highlight price--large' : 'price price--large';
        priceEl.innerHTML = priceHtml;

        if (unitPriceEl) {
          priceList.insertBefore(priceEl, unitPriceEl);
        } else {
          priceList.prepend(priceEl);
        }

        if (hasCompare) {
          const compareEl = document.createElement('span');
          compareEl.className = 'price price--compare';
          compareEl.innerHTML = compareHtml;
          priceEl.after(compareEl);
        }
      });
    }

    function scUpdateDiscountBadges(bonusProducts) {
      const bonusQty = (bonusProducts || []).length;
      const bonusPct = scGetBonusDiscountPercent();
      // Bonus slot badges always follow the theme "Bonus discount %" setting
      const bonusBadgeText = '-' + bonusPct + '%';

      document.querySelectorAll('.sc-badge-bonus, .sc-thumb-bonus-badge, .sc-badge-bonus-inline').forEach((el) => {
        if (!el.hasAttribute('data-sc-default-badge')) {
          el.setAttribute('data-sc-default-badge', (el.textContent || '').trim());
        }
        el.textContent = bonusBadgeText;
      });

      // PDP labels: with bonuses selected, show combined effective savings %
      // Update all (custom liquid price blocks + hidden .cusoo meta)
      const pdpLabels = document.querySelectorAll('.product-meta__label-list .label--highlight');
      pdpLabels.forEach((pdpLabel) => {
        if (!pdpLabel.hasAttribute('data-sc-default-label')) {
          pdpLabel.setAttribute('data-sc-default-label', pdpLabel.textContent || '');
        }
        if (bonusQty > 0) {
          const effectivePct = scGetEffectiveDiscountPercent(bonusProducts);
          if (effectivePct > 0) {
            const tpl = window.themeVariables?.strings?.collectionDiscount || 'Spare @savings@';
            pdpLabel.textContent = tpl.replace('@savings@', effectivePct + '%');
          }
        } else {
          pdpLabel.textContent = pdpLabel.getAttribute('data-sc-default-label') || pdpLabel.textContent;
        }
      });
    }

    /** Max bonus colors from theme setting (data-bonus-count), fallback = set size. */
    function scGetBonusCap() {
      if (!scIsBonusEnabled()) return 0;
      const fromAttr = parseInt(scGetSelectionWrapper()?.getAttribute('data-bonus-count') || '0', 10);
      if (fromAttr > 0) return fromAttr;
      return scGetBaseColorsCap();
    }
    /** Max selectable colors including bonus slots. */
    function scGetMaxColorsCap() {
      return scGetBaseColorsCap() + scGetBonusCap();
    }
    /** @deprecated use scGetBaseColorsCap / scGetMaxColorsCap */
    function scGetTotalColorsCap() {
      return scGetBaseColorsCap();
    }
    /**
     * Progressive reveal: when base set is complete, show filled bonus slots
     * plus one empty slot (until bonus cap is reached).
     */
    function scSyncBonusSlotVisibility(baseQty, bonusQty) {
      const baseCap = scGetBaseColorsCap();
      const bonusCap = scGetBonusCap();
      const baseComplete = scIsBonusEnabled() && baseQty >= baseCap;
      const visibleCount = baseComplete ? Math.min(bonusQty + 1, bonusCap) : 0;

      scQsBonusSlots().forEach((slot, index) => {
        if (index < visibleCount) {
          slot.removeAttribute('hidden');
          slot.setAttribute('aria-hidden', 'false');
        } else {
          slot.setAttribute('hidden', '');
          slot.setAttribute('aria-hidden', 'true');
        }
      });

      const modalEl = scGetColorModal();
      const bonusThumbs = modalEl
        ? Array.from(modalEl.querySelectorAll('#sc-modal-thumbnails .sc-thumb-slot-wrap--bonus')).sort(
            (a, b) =>
              parseInt(a.getAttribute('data-bonus-index') || '0', 10) -
              parseInt(b.getAttribute('data-bonus-index') || '0', 10)
          )
        : [];
      bonusThumbs.forEach((wrap, index) => {
        if (index < visibleCount) {
          wrap.removeAttribute('hidden');
        } else {
          wrap.setAttribute('hidden', '');
        }
      });
    }

    if (!scGetColorModal()) return;

    // === Schicht 2: Lazy access to single JSON product map ===
    let scProductsData = null;
    function scGetProductsData() {
      if (scProductsData) return scProductsData;
      const el = document.getElementById('sc-products-data');
      if (!el) { scProductsData = {}; return scProductsData; }
      try {
        scProductsData = JSON.parse(el.textContent);
      } catch (err) {
        console.error('sc-products-data parse error', err);
        scProductsData = {};
      }
      return scProductsData;
    }

    // === Schicht 1: Card index + lazy hydration ===
    const scCardsByProductId = new Map(); // pid (string) -> .sc-product-card-wrapper
    let scHydrateObserver = null;

    function scBuildCardIndex() {
      const modal = scGetColorModal();
      if (!modal) return;
      scCardsByProductId.clear();
      modal.querySelectorAll('.sc-product-card-wrapper').forEach((w) => {
        const pid = w.getAttribute('data-product-id');
        if (pid) scCardsByProductId.set(String(pid), w);
      });
    }

    function scApplyCardSelectionState(card, qty) {
      if (!card) return;
      const addBtn = card.querySelector('.sc-btn-add');
      const qtySelector = card.querySelector('.sc-qty-selector');
      const qtyValue = card.querySelector('.sc-qty-value');
      if (qty != null && qty > 0) {
        if (addBtn) addBtn.style.display = 'none';
        if (qtySelector) qtySelector.style.display = 'flex';
        if (qtyValue) qtyValue.textContent = qty;
      } else {
        if (addBtn) addBtn.style.display = 'flex';
        if (qtySelector) qtySelector.style.display = 'none';
      }
    }

    function scHydrateCard(wrapper) {
      if (wrapper.classList.contains('sc-hydrated')) return;
      const pid = wrapper.getAttribute('data-product-id');
      if (!pid) return;
      const data = scGetProductsData()[pid];
      if (!data) return;

      const tpl = document.getElementById('sc-card-template');
      if (!tpl) return;
      const frag = tpl.content.cloneNode(true);
      const card = frag.querySelector('.sc-product-card');
      if (!card) return;
      card.setAttribute('data-product-id', pid);
      card.setAttribute('data-variant-id', wrapper.getAttribute('data-variant-id') || '');
      card.setAttribute('data-product-handle', wrapper.getAttribute('data-product-handle') || '');

      // NEU badge
      const newBadge = card.querySelector('.sc-badge-new');
      if (newBadge && wrapper.getAttribute('data-has-new') === '1') newBadge.style.display = '';

      // Custom badges from JSON
      const badgesSlot = card.querySelector('.sc-product-badges-slot');
      if (badgesSlot && data.badgesHtml) badgesSlot.innerHTML = data.badgesHtml;

      // Carousel images + dots
      const carousel = card.querySelector('.sc-product-image-carousel');
      const dotsWrap = card.querySelector('.sc-image-dots');
      const imgs = (data.images_240 && data.images_240.length) ? data.images_240 : [];
      if (carousel) {
        if (imgs.length > 0) {
          imgs.forEach((url, idx) => {
            const slide = document.createElement('div');
            slide.className = 'sc-product-image-slide';
            slide.setAttribute('data-action', 'add');
            slide.setAttribute('data-index', String(idx));
            const img = document.createElement('img');
            img.src = url;
            // Meta in-app browsers (IG/FB) silently fail `loading="lazy"` on
            // images that mount inside an initially hidden modal — bypass it.
            if (!scIsInAppBrowser) img.loading = 'lazy';
            img.decoding = 'async';
            img.className = 'sc-product-image';
            img.alt = '';
            slide.appendChild(img);
            carousel.appendChild(slide);
          });
        }
      }
      if (dotsWrap) {
        const numDots = imgs.length;
        if (numDots > 1) {
          for (let i = 0; i < numDots; i++) {
            const dot = document.createElement('span');
            dot.className = 'sc-dot' + (i === 0 ? ' active' : '');
            dot.setAttribute('data-slide', String(i));
            dotsWrap.appendChild(dot);
          }
        } else {
          dotsWrap.style.display = 'none';
        }
      }

      // Apply current selection state from ScProductSet
      const selected = window.ScProductSet
        && window.ScProductSet.selectedProducts.find((p) => String(p.id) === String(pid));
      scApplyCardSelectionState(card, selected ? selected.qty : null);

      // Insert card before placeholder
      const placeholder = wrapper.querySelector('.sc-product-card-placeholder');
      if (placeholder) wrapper.insertBefore(card, placeholder);
      else wrapper.insertBefore(card, wrapper.firstChild);
      wrapper.classList.add('sc-hydrated');

      // Honor current "applied" color view: scroll carousel to second image
      if (carousel && imgs.length > 1) {
        const colorView = getCookie('sc_view_color') || 'product';
        if (colorView === 'applied') {
          requestAnimationFrame(() => {
            const w = carousel.offsetWidth;
            if (w > 0) carousel.scrollTo({ left: w, behavior: 'instant' });
          });
        }
      }
    }

    // === Infinite scroll: batched hydration ===
    // Hydrating every card up-front floods mobile WebViews (especially IG/FB
    // in-app browsers) with hundreds of concurrent image requests, which
    // causes broken-image placeholders and outright browser crashes on close.
    // Strategy: hydrate a small initial batch on modal open, then progressively
    // hydrate the next batch as the user scrolls toward the bottom.
    const SC_INITIAL_BATCH = 12; // ~ first 4 rows on 3-col mobile grid
    const SC_BATCH_SIZE = 9;     // ~ 3 more rows per scroll trigger
    const SC_SCROLL_THRESHOLD_PX = 1000;
    let scScrollRaf = 0;

    // Hydrate up to `count` visible (non-filtered, not-yet-hydrated) cards
    // in DOM order. Returns the number of cards actually hydrated.
    function scHydrateNextBatch(count) {
      const modal = scGetColorModal();
      if (!modal) return 0;
      const wrappers = modal.querySelectorAll('.sc-product-card-wrapper');
      let hydrated = 0;
      for (let i = 0; i < wrappers.length && hydrated < count; i++) {
        const w = wrappers[i];
        if (w.classList.contains('sc-hydrated')) continue;
        // Skip filter-hidden wrappers (display:none via dynamic stylesheet);
        // they remain in DOM order and will be picked up if the filter changes.
        if (w.offsetParent === null) continue;
        scHydrateCard(w);
        hydrated++;
      }
      return hydrated;
    }

    function scOnModalScroll() {
      const modal = scGetColorModal();
      if (!modal) return;
      const body = modal.querySelector('.sc-modal-body');
      if (!body) return;

      // Trigger the next batch based on the position of the last hydrated card,
      // NOT the total scrollHeight: unhydrated placeholders inflate scrollHeight
      // (aspect-ratio: 5/8), so a fixed "distance from bottom" threshold would
      // only fire near the very end of the list. Loading when the last hydrated
      // card approaches the viewport gives a smooth, "endless" feel.
      const hydratedCards = modal.querySelectorAll('.sc-product-card-wrapper.sc-hydrated');
      if (!hydratedCards.length) {
        scHydrateNextBatch(SC_BATCH_SIZE);
        scMaybeLoadMoreColorPages();
        return;
      }
      const lastHydrated = hydratedCards[hydratedCards.length - 1];
      const lastRect = lastHydrated.getBoundingClientRect();
      const bodyRect = body.getBoundingClientRect();
      const distance = lastRect.bottom - bodyRect.bottom;
      if (distance < SC_SCROLL_THRESHOLD_PX) {
        scHydrateNextBatch(SC_BATCH_SIZE);
      }
      scMaybeLoadMoreColorPages();
    }

    function scOnModalScrollRaf() {
      if (scScrollRaf) return;
      scScrollRaf = requestAnimationFrame(function () {
        scScrollRaf = 0;
        scOnModalScroll();
      });
    }

    function scSetupHydrateObserver() {
      const modal = scGetColorModal();
      if (!modal) return;

      // Tear down any legacy IntersectionObserver (kept for hot-reload safety).
      if (scHydrateObserver) {
        scHydrateObserver.disconnect();
        scHydrateObserver = null;
      }

      scBuildCardIndex();

      const body = modal.querySelector('.sc-modal-body');
      if (body && !body.dataset.scInfiniteBound) {
        body.dataset.scInfiniteBound = '1';
        body.addEventListener('scroll', scOnModalScrollRaf, { passive: true });
      }
    }

    // Called when the modal opens or after a filter change. Hydrates enough
    // cards to fill the viewport without flooding the network.
    function scHydrateAllCards() {
      scBuildCardIndex();
      scHydrateNextBatch(SC_INITIAL_BATCH);
      scMaybeLoadMoreColorPages();
    }

    let scColorPageLoading = false;

    function scGetColorPageState() {
      const grid = scGetProductGrid();
      if (!grid) return null;
      return {
        grid,
        url: grid.getAttribute('data-sc-collection-url') || '',
        page: parseInt(grid.getAttribute('data-sc-page') || '1', 10),
        pages: parseInt(grid.getAttribute('data-sc-pages') || '1', 10),
      };
    }

    function scHasMoreColorPages() {
      const state = scGetColorPageState();
      return !!(state && state.url && state.page < state.pages);
    }

    function scGetLastVisibleCard(modal) {
      const wrappers = modal.querySelectorAll('.sc-product-card-wrapper');
      for (let i = wrappers.length - 1; i >= 0; i--) {
        if (wrappers[i].offsetParent !== null) return wrappers[i];
      }
      return null;
    }

    function scSetColorPageLoader(visible) {
      const modal = scGetColorModal();
      const loader = modal && modal.querySelector('.sc-product-grid-loader');
      if (!loader) return;
      loader.hidden = !visible;
      loader.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function scMaybeLoadMoreColorPages() {
      if (scColorPageLoading || !scHasMoreColorPages()) return;
      const modal = scGetColorModal();
      if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
      const body = modal.querySelector('.sc-modal-body');
      if (!body) return;

      const lastVisible = scGetLastVisibleCard(modal);
      if (!lastVisible) {
        scLoadNextColorPage();
        return;
      }
      const lastRect = lastVisible.getBoundingClientRect();
      const bodyRect = body.getBoundingClientRect();
      if (lastRect.bottom - bodyRect.bottom < SC_SCROLL_THRESHOLD_PX) {
        scLoadNextColorPage();
      }
    }

    function scLoadNextColorPage() {
      const state = scGetColorPageState();
      if (!state || scColorPageLoading || !state.url || state.page >= state.pages) return Promise.resolve(false);
      scColorPageLoading = true;
      scSetColorPageLoader(true);
      const nextPage = state.page + 1;
      const sep = state.url.indexOf('?') >= 0 ? '&' : '?';
      const url = state.url + sep + 'page=' + nextPage + '&view=sc-color-products';

      return fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error('color page ' + nextPage);
          return res.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const jsonEl = doc.querySelector('.sc-products-data-page');
          if (jsonEl) {
            const extra = JSON.parse(jsonEl.textContent || '{}');
            Object.assign(scGetProductsData(), extra);
          }
          const incoming = doc.querySelectorAll('.sc-product-card-wrapper');
          const frag = document.createDocumentFragment();
          incoming.forEach((card) => {
            const pid = card.getAttribute('data-product-id');
            if (pid && !scCardsByProductId.has(String(pid))) {
              frag.appendChild(document.importNode(card, true));
            }
          });
          state.grid.appendChild(frag);
          const fetchedGrid = doc.querySelector('.sc-product-grid');
          state.grid.setAttribute('data-sc-page', String(nextPage));
          if (fetchedGrid && fetchedGrid.getAttribute('data-sc-pages')) {
            state.grid.setAttribute('data-sc-pages', fetchedGrid.getAttribute('data-sc-pages'));
          }
          scBuildCardIndex();
          const addedVisible = scHydrateNextBatch(SC_BATCH_SIZE) > 0;
          return { loaded: true, addedVisible };
        })
        .catch((err) => {
          console.error('sc color page load', err);
          return { loaded: false, addedVisible: false };
        })
        .then((result) => {
          scColorPageLoading = false;
          scSetColorPageLoader(false);
          if (result.loaded && !result.addedVisible) {
            requestAnimationFrame(scMaybeLoadMoreColorPages);
          }
          return result.loaded;
        });
    }

    // Tear down every hydrated card and free its <img> memory. We do this on
    // modal close because users scroll through many color cards in one session,
    // and the accumulated decoded-image memory crashes constrained WebViews
    // (most notably IG/FB in-app browsers on iOS) when the confirm action then
    // tries to allocate more images on the main product screen.
    function scDehydrateAllCards() {
      const modal = scGetColorModal();
      if (!modal) return;
      modal.querySelectorAll('.sc-product-card-wrapper.sc-hydrated').forEach((wrapper) => {
        const card = wrapper.querySelector('.sc-product-card');
        if (card) {
          // Explicitly drop image sources first so the browser can release
          // decoded pixel buffers immediately instead of waiting for GC.
          card.querySelectorAll('img').forEach((img) => img.removeAttribute('src'));
          card.remove();
        }
        wrapper.classList.remove('sc-hydrated');
      });
      // Reset scroll so the next open starts at the top of the grid.
      const body = modal.querySelector('.sc-modal-body');
      if (body) body.scrollTop = 0;
    }

    // === Schicht 5: Carousel events via global delegation on .sc-modal-body ===
    function scInitCarouselDelegation() {
      const modal = scGetColorModal();
      if (!modal) return;
      const body = modal.querySelector('.sc-modal-body');
      if (!body || body.dataset.scDelegationBound) return;
      body.dataset.scDelegationBound = '1';

      const dragMap = new WeakMap();

      // Capture-phase click suppression after drag
      body.addEventListener('click', (e) => {
        const carousel = e.target.closest('.sc-product-image-carousel');
        if (!carousel) return;
        const state = dragMap.get(carousel);
        if (state && state.suppress) {
          state.suppress = false;
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      // Dot click
      body.addEventListener('click', (e) => {
        const dot = e.target.closest('.sc-dot');
        if (!dot) return;
        const wrap = dot.closest('.sc-product-image-wrap');
        const carousel = wrap && wrap.querySelector('.sc-product-image-carousel');
        if (!carousel) return;
        e.stopPropagation();
        const slideIdx = parseInt(dot.getAttribute('data-slide') || '0', 10);
        const width = carousel.offsetWidth;
        carousel.scrollTo({ left: slideIdx * width, behavior: 'smooth' });
      });

      // Drag (touch + mouse) via pointer events
      body.addEventListener('pointerdown', (e) => {
        const carousel = e.target.closest('.sc-product-image-carousel');
        if (!carousel) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        const state = {
          startScroll: carousel.scrollLeft,
          startX: e.clientX,
          startY: e.clientY,
          moved: false,
          suppress: false,
        };
        dragMap.set(carousel, state);
        const onMove = (ev) => {
          if (Math.abs(ev.clientX - state.startX) > 5 || Math.abs(ev.clientY - state.startY) > 5) state.moved = true;
          if (Math.abs(carousel.scrollLeft - state.startScroll) > 3) state.moved = true;
        };
        const onUp = () => {
          document.removeEventListener('pointermove', onMove);
          document.removeEventListener('pointerup', onUp);
          document.removeEventListener('pointercancel', onUp);
          if (state.moved || Math.abs(carousel.scrollLeft - state.startScroll) > 3) {
            state.suppress = true;
          }
        };
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
        document.addEventListener('pointercancel', onUp);
      });

      // Scroll-driven dot active state. Scroll does not bubble, but capture works for non-bubbling events.
      body.addEventListener('scroll', (e) => {
        const carousel = e.target;
        if (!(carousel instanceof Element) || !carousel.matches('.sc-product-image-carousel')) return;
        const wrap = carousel.parentElement;
        const dotsWrap = wrap && wrap.querySelector('.sc-image-dots');
        if (!dotsWrap) return;
        const width = carousel.offsetWidth;
        const activeIndex = Math.round(carousel.scrollLeft / width);
        dotsWrap.querySelectorAll('.sc-dot').forEach((d, i) => {
          d.classList.toggle('active', i === activeIndex);
        });
      }, { capture: true, passive: true });
    }

    // === Schicht 4: collection filter via attribute + dynamic CSS ===
    let scFilterStyleEl = null;
    function scApplyCollectionFilter(filterValue) {
      const modal = scGetColorModal();
      if (!modal) return;
      modal.dataset.activeFilter = filterValue || 'all';
      if (!scFilterStyleEl) {
        scFilterStyleEl = document.createElement('style');
        modal.appendChild(scFilterStyleEl);
      }
      if (!filterValue || filterValue === 'all') {
        scFilterStyleEl.textContent = '';
      } else {
        const escaped = (window.CSS && CSS.escape) ? CSS.escape(filterValue) : filterValue.replace(/"/g, '\\"');
        scFilterStyleEl.textContent =
          '#sc-color-modal[data-active-filter="' + escaped + '"] ' +
          '.sc-product-card-wrapper:not([data-collections~="' + escaped + '"]) { display: none; }';
      }
    }

    // Globale Logik-Klasse für das Produkt-Set
    window.ScProductSet = {
      selectedProducts: [], // [{ id, variant_id, title, image, qty }] — required set colors
      bonusProducts: [], // flat list of bonus units [{ id, variant_id, title, image }] — sticky, max = bonusCap
      lastSelectedColorTitle: null,

      getBaseQty: function () {
        return this.selectedProducts.reduce((acc, curr) => acc + curr.qty, 0);
      },

      getBonusQty: function () {
        return this.bonusProducts.length;
      },

      getTotalQty: function () {
        return this.getBaseQty() + this.getBonusQty();
      },

      addProduct: function (productData) {
        productData.id = String(productData.id);
        const baseCap = scGetBaseColorsCap();
        const baseQty = this.getBaseQty();

        // Fill required set slots first
        if (baseQty < baseCap) {
          let existing = this.selectedProducts.find((p) => p.id === productData.id);
          if (existing) {
            existing.qty += 1;
          } else {
            this.selectedProducts.push({ ...productData, qty: 1 });
          }
          this.lastSelectedColorTitle = productData.title;
          this.renderModalState();
          return true;
        }

        // Bonus slots: up to baseCap extra colors at discount
        if (scIsBonusEnabled() && this.getBonusQty() < scGetBonusCap()) {
          this.bonusProducts.push({
            id: productData.id,
            variant_id: productData.variant_id,
            title: productData.title,
            image: productData.image,
            badgesHtml: productData.badgesHtml,
            price: productData.price,
            compare_at_price: productData.compare_at_price,
          });
          this.lastSelectedColorTitle = productData.title;
          this.renderModalState();
          return true;
        }

        return false;
      },

      removeBonusAt: function (index) {
        if (index < 0 || index >= this.bonusProducts.length) return;
        this.bonusProducts.splice(index, 1);
        if (this.bonusProducts.length > 0) {
          this.lastSelectedColorTitle = this.bonusProducts[this.bonusProducts.length - 1].title;
        } else if (this.selectedProducts.length > 0) {
          this.lastSelectedColorTitle = this.selectedProducts[this.selectedProducts.length - 1].title;
        } else {
          this.lastSelectedColorTitle = null;
        }
        this.renderModalState();
      },

      removeProduct: function (productId) {
        productId = String(productId);

        let existingIndex = this.selectedProducts.findIndex((p) => p.id === productId);
        if (existingIndex > -1) {
          if (this.selectedProducts[existingIndex].qty > 1) {
            this.selectedProducts[existingIndex].qty -= 1;
          } else {
            this.selectedProducts.splice(existingIndex, 1);
            if (this.selectedProducts.length > 0) {
              if (!this.selectedProducts.find((p) => p.title === this.lastSelectedColorTitle)) {
                this.lastSelectedColorTitle = this.selectedProducts[this.selectedProducts.length - 1].title;
              }
            } else if (this.bonusProducts.length > 0) {
              this.lastSelectedColorTitle = this.bonusProducts[this.bonusProducts.length - 1].title;
            } else {
              this.lastSelectedColorTitle = null;
            }
          }
          this.renderModalState();
          return;
        }

        // Fallback: remove last matching bonus unit
        for (let i = this.bonusProducts.length - 1; i >= 0; i--) {
          if (String(this.bonusProducts[i].id) === productId) {
            this.removeBonusAt(i);
            return;
          }
        }
      },

      openPreviewModal: function (productData) {
        const previewModal = document.getElementById('sc-nail-preview-modal');
        if (!previewModal) return;

        // Set Text
        const titleEl = document.getElementById('sc-preview-title');
        const descEl = document.getElementById('sc-preview-description');
        if (titleEl) titleEl.textContent = productData.title;
        if (descEl) descEl.textContent = productData.description;

        // Set Images
        const carouselWrap = document.getElementById('sc-preview-carousel');
        const thumbsWrap = document.getElementById('sc-preview-thumbnails');
        const dotsWrap = document.getElementById('sc-preview-dots');

        if (carouselWrap && thumbsWrap && dotsWrap) {
          carouselWrap.innerHTML = '';
          thumbsWrap.innerHTML = '';
          dotsWrap.innerHTML = '';

          if (productData.images && productData.images.length > 0) {
            productData.images.forEach((imgUrl, index) => {
              // Carousel Slide
              const slide = document.createElement('div');
              slide.className = 'sc-preview-image-slide';
              slide.innerHTML = `<img src="${imgUrl}" alt="">`;
              carouselWrap.appendChild(slide);

              // Dot
              const dot = document.createElement('div');
              dot.className = 'sc-preview-dot' + (index === 0 ? ' active' : '');
              dotsWrap.appendChild(dot);

              // Thumbnail
              const thumb = document.createElement('div');
              thumb.className = 'sc-preview-thumbnail' + (index === 0 ? ' active' : '');
              thumb.innerHTML = `<img src="${imgUrl}" alt="">`;

              thumb.addEventListener('click', () => {
                const width = carouselWrap.offsetWidth;
                carouselWrap.scrollTo({
                  left: index * width,
                  behavior: 'smooth',
                });
              });

              thumbsWrap.appendChild(thumb);
            });

            // Update active states on scroll
            carouselWrap.onscroll = () => {
              const scrollLeft = carouselWrap.scrollLeft;
              const width = carouselWrap.offsetWidth;
              const activeIndex = Math.round(scrollLeft / width);

              dotsWrap.querySelectorAll('.sc-preview-dot').forEach((d, i) => {
                d.classList.toggle('active', i === activeIndex);
              });
              thumbsWrap.querySelectorAll('.sc-preview-thumbnail').forEach((t, i) => {
                t.classList.toggle('active', i === activeIndex);
              });
            };

            // Mouse Drag (Swipe) Support für Desktop
            let isDown = false;
            let startX;
            let scrollLeftPos;

            carouselWrap.style.cursor = 'grab';

            carouselWrap.addEventListener('mousedown', (e) => {
              isDown = true;
              carouselWrap.style.cursor = 'grabbing';
              carouselWrap.style.scrollBehavior = 'auto'; // Verhindert Ruckeln beim Draggen
              carouselWrap.style.scrollSnapType = 'none';
              startX = e.pageX - carouselWrap.offsetLeft;
              scrollLeftPos = carouselWrap.scrollLeft;
            });

            carouselWrap.addEventListener('mouseleave', () => {
              if (!isDown) return;
              isDown = false;
              carouselWrap.style.cursor = 'grab';
              carouselWrap.style.scrollBehavior = 'smooth';
              carouselWrap.style.scrollSnapType = 'x mandatory';
            });

            carouselWrap.addEventListener('mouseup', () => {
              if (!isDown) return;
              isDown = false;
              carouselWrap.style.cursor = 'grab';
              carouselWrap.style.scrollBehavior = 'smooth';
              carouselWrap.style.scrollSnapType = 'x mandatory';

              // Zum nächsten/vorherigen Snap-Punkt rutschen
              const width = carouselWrap.offsetWidth;
              const currentScroll = carouselWrap.scrollLeft;
              const activeIndex = Math.round(currentScroll / width);
              carouselWrap.scrollTo({ left: activeIndex * width, behavior: 'smooth' });
            });

            carouselWrap.addEventListener('mousemove', (e) => {
              if (!isDown) return;
              e.preventDefault();
              const x = e.pageX - carouselWrap.offsetLeft;
              const walk = (x - startX) * 1.5;
              carouselWrap.scrollLeft = scrollLeftPos - walk;
            });
          }
        }

        // Set Status Text
        const statusElArray = document.querySelectorAll('.sc-preview-status');
        statusElArray.forEach((statusEl) => {
          if (statusEl) {
            statusEl.textContent = `${this.getTotalQty()} von ${scGetBaseColorsCap()} Farben ausgewählt`;
          }
        });

        // Setup Button
        const addBtn = document.querySelectorAll('#sc-preview-add-btn');
        if (addBtn.length > 0) {
          // Clone and replace to remove old event listeners
          addBtn.forEach((btn) => {
            const newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);
            if (this.getTotalQty() >= scGetMaxColorsCap()) {
              newBtn.style.opacity = '0.5';
              newBtn.style.cursor = 'not-allowed';
              newBtn.textContent = 'Limit erreicht';
            } else {
              newBtn.style.opacity = '1';
              newBtn.style.cursor = 'pointer';
              newBtn.textContent = 'Farbe wählen';
              newBtn.addEventListener('click', () => {
                const success = this.addProduct({
                  id: productData.id,
                  variant_id: productData.variant_id,
                  title: productData.title,
                  image: productData.images[0],
                  badgesHtml: productData.badgesHtml,
                  price: productData.price,
                  compare_at_price: productData.compare_at_price,
                });
                if (success) {
                  // Update status text instantly
                  if (statusElArray) {
                    statusElArray.forEach((statusEl) => {
                      if (statusEl) {
                        statusEl.textContent = `${this.getTotalQty()} von ${scGetBaseColorsCap()} Farben ausgewählt`;
                      }
                    });
                  }
                  previewModal.setAttribute('aria-hidden', 'true');
                  scSyncModalBodyScroll();
                  if (this.getTotalQty() >= scGetMaxColorsCap()) {
                    newBtn.style.opacity = '0.5';
                    newBtn.style.cursor = 'not-allowed';
                    newBtn.textContent = 'Limit erreicht';
                  }
                }
              });
            }
          });
        }

        // Open Modal
        previewModal.setAttribute('aria-hidden', 'false');
        scSyncModalBodyScroll();

        // Reset scroll position
        if (carouselWrap) {
          setTimeout(() => {
            carouselWrap.scrollTo({ left: 0, behavior: 'instant' });
          }, 0);
        }
      },

      _previousSelectedState: new Map(), // pid -> qty

      renderModalState: function () {
        const total = this.getTotalQty();
        const baseQty = this.getBaseQty();
        const bonusQty = this.getBonusQty();

        // === Schicht 3: diff-based card UI updates ===
        const currentMap = new Map(this.selectedProducts.map((p) => [String(p.id), p.qty]));
        this.bonusProducts.forEach((prod) => {
          const bid = String(prod.id);
          currentMap.set(bid, (currentMap.get(bid) || 0) + 1);
        });

        // Removed items (or qty zero): reset their card UI
        this._previousSelectedState.forEach((_qty, pid) => {
          if (!currentMap.has(pid)) {
            const wrapper = scCardsByProductId.get(pid);
            const card = wrapper && wrapper.querySelector('.sc-product-card');
            if (card) scApplyCardSelectionState(card, null);
          }
        });
        // Added or qty-changed
        currentMap.forEach((qty, pid) => {
          if (this._previousSelectedState.get(pid) !== qty) {
            const wrapper = scCardsByProductId.get(pid);
            const card = wrapper && wrapper.querySelector('.sc-product-card');
            if (card) scApplyCardSelectionState(card, qty);
            // If card not yet hydrated, the state is read from ScProductSet on hydrate.
          }
        });
        this._previousSelectedState = currentMap;

        // Update Thumbnails im Modal Footer
        let thumbIndex = 0;
        const baseCap = scGetBaseColorsCap();
        scSyncBonusSlotVisibility(baseQty, bonusQty);
        const modalEl = scGetColorModal();
        const slotWraps = modalEl
          ? Array.from(modalEl.querySelectorAll('#sc-modal-thumbnails .sc-thumb-slot-wrap')).filter(
              (wrap) => !wrap.hasAttribute('hidden')
            )
          : [];

        // Reset all slot wraps to empty state
        slotWraps.forEach((wrap) => {
          wrap.classList.remove('has-product');
          const slot = wrap.querySelector('.sc-thumb-slot');
          if (slot) {
            slot.classList.remove('has-product', 'show-trash');
            // Preserve bonus badge if present
            const bonusBadge = wrap.querySelector('.sc-thumb-bonus-badge');
            slot.innerHTML =
              '<svg class="sc-thumb-empty-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="1.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
            if (bonusBadge && !wrap.contains(bonusBadge)) {
              wrap.insertBefore(bonusBadge, wrap.firstChild);
            }
          }
          const nameEl = wrap.querySelector('.sc-thumb-name');
          if (nameEl) nameEl.textContent = '';
        });

        function scFillThumb(wrap, prod) {
          if (!wrap || !prod) return;
          const slot = wrap.querySelector('.sc-thumb-slot');
          const nameEl = wrap.querySelector('.sc-thumb-name');
          if (slot && prod.image) {
            slot.innerHTML =
              '<img src="' +
              prod.image +
              '" alt="' +
              (prod.title || '').replace(/"/g, '&quot;') +
              '">' +
              '<button type="button" class="sc-thumb-remove" aria-label="Entfernen" data-product-id="' +
              prod.id +
              '"' +
              (wrap.getAttribute('data-bonus') === 'true'
                ? ' data-bonus="true" data-bonus-index="' +
                  (wrap.getAttribute('data-bonus-index') || '0') +
                  '"'
                : '') +
              '>' +
              '<svg viewBox="0 0 24 24" fill="none" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
              '</button>';
            slot.classList.add('has-product');
          }
          wrap.classList.add('has-product');
          if (nameEl) nameEl.textContent = prod.title || '';
        }

        // Fill base thumbnails
        this.selectedProducts.forEach((prod) => {
          for (let i = 0; i < prod.qty; i++) {
            if (thumbIndex >= baseCap || thumbIndex >= slotWraps.length) break;
            const wrap = slotWraps[thumbIndex];
            if (wrap && wrap.getAttribute('data-bonus') === 'true') break;
            scFillThumb(wrap, prod);
            thumbIndex++;
          }
        });

        // Fill bonus thumbnails (sticky, progressive)
        const bonusWraps = slotWraps
          .filter((w) => w.getAttribute('data-bonus') === 'true')
          .sort(
            (a, b) =>
              parseInt(a.getAttribute('data-bonus-index') || '0', 10) -
              parseInt(b.getAttribute('data-bonus-index') || '0', 10)
          );
        this.bonusProducts.forEach((prod, index) => {
          if (index < bonusWraps.length) {
            scFillThumb(bonusWraps[index], prod);
          }
        });

        // Update Confirm Button Count (required base colors)
        const confirmCountEl = document.querySelector('.sc-confirm-count');
        if (confirmCountEl) {
          confirmCountEl.textContent = `(${baseQty}/${baseCap})`;
        }

        // Update progress bar (X von N gewählt + width) — base set completion
        const progressCurrentEl = modalEl ? modalEl.querySelector('.sc-progress-current') : null;
        if (progressCurrentEl) progressCurrentEl.textContent = String(baseQty);
        const progressSuffixEl = modalEl ? modalEl.querySelector('.sc-progress-suffix') : null;
        if (progressSuffixEl) progressSuffixEl.textContent = baseQty >= baseCap ? 'Farben gewählt' : 'gewählt';
        const progressFillEl = modalEl ? modalEl.querySelector('.sc-modal-progress-bar-fill') : null;
        if (progressFillEl) {
          const pct = baseCap > 0 ? Math.min(100, (baseQty / baseCap) * 100) : 0;
          progressFillEl.style.width = pct + '%';
        }

        // Show CTA only when all required colors are chosen (slide-up reveal)
        const ctaWrap = modalEl ? modalEl.querySelector('.sc-btn-confirm-wrap') : null;
        if (ctaWrap) {
          ctaWrap.setAttribute('aria-hidden', baseQty >= baseCap ? 'false' : 'true');
        }
      },

      transferToMainScreen: function () {
        const total = this.getTotalQty();
        const baseQty = this.getBaseQty();
        const bonusQty = this.getBonusQty();
        const baseCap = scGetBaseColorsCap();
        scSyncBonusSlotVisibility(baseQty, bonusQty);

        // 1. Header Count Updaten (required set colors)
        const scCountDisplay = document.getElementById('sc-selected-count');
        if (scCountDisplay) {
          scCountDisplay.textContent = baseQty;
        }

        // 2. Main Slots mit Bildern befüllen (base + optional bonus)
        const mainGridSlots = Array.from(scQsMainGridSlots());
        const bonusSlots = scQsBonusSlots();
        const allSlots = mainGridSlots.concat(bonusSlots);

        function scResetSlot(slot) {
          if (!slot) return;
          slot.classList.remove('sc-is-active');
          slot.removeAttribute('data-product-id');

          const placeholder = slot.querySelector('.sc-color-slot-placeholder');
          const imgWrap = slot.querySelector('.sc-color-slot-image');
          const removeBtn = slot.querySelector('.sc-remove-color');
          const label = slot.querySelector('.sc-color-label');
          const slotBadges = slot.querySelector('.sc-slot-badges');
          const bonusBadge = slot.querySelector('.sc-badge-bonus');
          const priceEl = slot.querySelector('.sc-color-slot-price');
          const priceCurrent = slot.querySelector('.sc-color-slot-price-current');
          const priceCompare = slot.querySelector('.sc-color-slot-price-compare');

          if (placeholder) placeholder.style.display = 'flex';
          if (imgWrap) {
            imgWrap.style.display = 'none';
            imgWrap.innerHTML = '';
          }
          if (removeBtn) removeBtn.style.display = 'none';
          if (label) label.textContent = label.getAttribute('data-default-label');
          if (slotBadges) {
            slotBadges.innerHTML = '';
            slotBadges.style.display = 'none';
          }
          if (bonusBadge) bonusBadge.style.display = '';
          if (priceEl) {
            priceEl.hidden = true;
            priceEl.setAttribute('aria-hidden', 'true');
          }
          if (priceCurrent) priceCurrent.textContent = '';
          if (priceCompare) priceCompare.textContent = '';
        }

        function scFillSlotPrice(slot, prod) {
          const priceEl = slot.querySelector('.sc-color-slot-price');
          if (!priceEl || !scShowSlotPrices()) return;
          if (slot.getAttribute('data-bonus') !== 'true') return;

          const priceCurrent = priceEl.querySelector('.sc-color-slot-price-current');
          const priceCompare = priceEl.querySelector('.sc-color-slot-price-compare');

          const currentCents = scBonusUnitPriceCents(prod);
          const compareCents = scBonusUnitCompareCents(prod);

          if (priceCurrent) priceCurrent.textContent = scFormatMoney(currentCents);
          if (priceCompare) {
            priceCompare.textContent = compareCents > currentCents ? scFormatMoney(compareCents) : '';
          }
          priceEl.hidden = false;
          priceEl.setAttribute('aria-hidden', 'false');
        }

        function scFillSlot(slot, prod) {
          if (!slot || !prod) return;
          slot.classList.add('sc-is-active');
          slot.setAttribute('data-product-id', prod.id);

          const placeholder = slot.querySelector('.sc-color-slot-placeholder');
          const imgWrap = slot.querySelector('.sc-color-slot-image');
          const removeBtn = slot.querySelector('.sc-remove-color');
          const label = slot.querySelector('.sc-color-label');
          const bonusBadge = slot.querySelector('.sc-badge-bonus');
          const isBonus = slot.getAttribute('data-bonus') === 'true';

          let slotBadges = slot.querySelector('.sc-slot-badges');
          if (!slotBadges) {
            slotBadges = document.createElement('div');
            slotBadges.className = 'sc-slot-badges sc-product-badges';
            slotBadges.style.position = 'absolute';
            slotBadges.style.top = '4px';
            slotBadges.style.left = '4px';
            slotBadges.style.zIndex = '2';
            slotBadges.style.margin = '0';
            slotBadges.style.flexDirection = 'column';
            slotBadges.style.alignItems = 'flex-start';
            const inner = slot.querySelector('.sc-color-slot-inner');
            if (inner) inner.appendChild(slotBadges);
          }

          if (placeholder) placeholder.style.display = 'none';
          if (imgWrap && prod.image) {
            imgWrap.style.display = 'block';
            imgWrap.innerHTML = `<img src="${prod.image}" alt="${prod.title}">`;
          }

          // Hide Bestseller/Restock etc. on selected slots so they don't cover % badges
          if (slotBadges) {
            slotBadges.innerHTML = '';
            slotBadges.style.display = 'none';
          }
          if (bonusBadge) bonusBadge.style.display = isBonus ? '' : 'none';

          if (removeBtn) removeBtn.style.display = 'flex';
          if (label) label.textContent = prod.title;
          scFillSlotPrice(slot, prod);
        }

        allSlots.forEach(scResetSlot);

        let slotIndex = 0;
        this.selectedProducts.forEach((prod) => {
          for (let i = 0; i < prod.qty; i++) {
            if (slotIndex >= mainGridSlots.length) break;
            scFillSlot(mainGridSlots[slotIndex], prod);
            slotIndex++;
          }
        });

        if (baseQty >= baseCap) {
          this.bonusProducts.forEach((prod, index) => {
            if (index < bonusSlots.length) {
              scFillSlot(bonusSlots[index], prod);
            }
          });
        }

        // 3. ATC Button Logic — ready when required set colors are selected
        const scAtcEl = document.getElementById('sc-add-to-cart-button');
        if (baseQty >= baseCap) {
          if (scAtcEl) {
            scAtcEl.innerHTML = scBuildReadyAtcHtml(this.bonusProducts);
          }
        } else {
          if (scAtcEl) {
            scAtcEl.textContent = scAtcEl.getAttribute('data-not-ready');
          }
        }

        // 4. Sync % badges (bonus slots + PDP) to effective combined discount
        scUpdateDiscountBadges(this.bonusProducts);
        scUpdateProductMetaPrice(this.bonusProducts);

        // 5. Congrats Banner Logic
        const congratsBanner = document.querySelector('.sc-color-selection-congrats');
        if (congratsBanner) {
          if (total > 0 && this.lastSelectedColorTitle) {
            congratsBanner.setAttribute('aria-hidden', 'false');

            const titleEl = congratsBanner.querySelector('.sc-color-selection-congrats-title');
            const contentEl = congratsBanner.querySelector('.sc-color-selection-congrats-content');

            const safeTitle = this.lastSelectedColorTitle.replace(/</g, '&lt;').replace(/>/g, '&gt;');

            if (titleEl) {
              const origText = titleEl.getAttribute('data-original-text') || titleEl.textContent;
              if (!titleEl.hasAttribute('data-original-text')) {
                titleEl.setAttribute('data-original-text', origText);
              }
              titleEl.textContent = origText.replace(/\[farbe\]/gi, this.lastSelectedColorTitle);
            }
            if (contentEl) {
              const origText = contentEl.getAttribute('data-original-text') || contentEl.innerHTML;
              if (!contentEl.hasAttribute('data-original-text')) {
                contentEl.setAttribute('data-original-text', origText);
              }
              contentEl.innerHTML = origText.replace(/\[farbe\]/gi, safeTitle);

              if (baseQty >= baseCap) {
                contentEl.style.display = 'block';
              } else {
                contentEl.style.display = 'none';
              }
            }
          } else {
            congratsBanner.setAttribute('aria-hidden', 'true');
          }
        }
      },
    };

    function applyViewSettings(colorView, gridView) {
      const productGrid = scGetProductGrid();
      if (gridView === 'large') {
        productGrid?.classList.add('sc-product-grid--large');
      } else {
        productGrid?.classList.remove('sc-product-grid--large');
      }

      const modal = scGetColorModal();
      if (modal) {
        modal.querySelectorAll('.sc-product-image-carousel').forEach((carousel) => {
          const width = carousel.offsetWidth;
          if (colorView === 'applied' && carousel.children.length > 1) {
            carousel.scrollTo({ left: width, behavior: 'instant' });
          } else {
            carousel.scrollTo({ left: 0, behavior: 'instant' });
          }
        });
      }

      document.querySelectorAll('.sc-setting-option').forEach((opt) => {
        opt.classList.remove('active');
        const group = opt.getAttribute('data-setting-group');
        const val = opt.getAttribute('data-setting-value');
        if (group === 'color' && val === colorView) {
          opt.classList.add('active');
        }
        if (group === 'grid' && val === gridView) {
          opt.classList.add('active');
        }
      });
    }

    function scReadProductDataFromWrapper(wrapper) {
      if (!wrapper) return null;
      const pid = wrapper.getAttribute('data-product-id');
      if (!pid) return null;
      const data = scGetProductsData()[pid];
      if (data) {
        return {
          id: String(data.id),
          variant_id: data.variant_id,
          title: data.title,
          image: data.thumb || (data.images_240 && data.images_240[0]) || '',
          badgesHtml: data.badgesHtml || '',
          price: data.price || 0,
          compare_at_price: data.compare_at_price || 0,
        };
      }
      // Fallback: from wrapper attributes (data may be missing if JSON failed)
      const titleEl = wrapper.querySelector('.sc-product-title');
      return {
        id: pid,
        variant_id: wrapper.getAttribute('data-variant-id'),
        title: titleEl ? titleEl.textContent.trim() : '',
        image: '',
        badgesHtml: '',
        price: 0,
        compare_at_price: 0,
      };
    }

    let scPreviewDrag = null;

    document.addEventListener('mousedown', function (e) {
      const area = e.target.closest('#sc-color-modal .sc-product-card-wrapper [data-action="preview"]');
      if (!area) return;
      const wrapper = area.closest('.sc-product-card-wrapper');
      scPreviewDrag = {
        area,
        wrapper,
        startX: e.pageX,
        startY: e.pageY,
        dragging: false,
      };
    });

    document.addEventListener('mousemove', function (e) {
      if (!scPreviewDrag) return;
      const diffX = Math.abs(e.pageX - scPreviewDrag.startX);
      const diffY = Math.abs(e.pageY - scPreviewDrag.startY);
      if (diffX > 3 || diffY > 3) {
        scPreviewDrag.dragging = true;
      }
    });

    document.addEventListener('mouseup', function (e) {
      if (!scPreviewDrag) return;
      const payload = scPreviewDrag;
      scPreviewDrag = null;
      if (payload.dragging || !payload.wrapper) return;
      if (e.target.closest('.sc-product-image-carousel')) return;
      const pid = payload.wrapper.getAttribute('data-product-id');
      if (!pid) return;
      const data = scGetProductsData()[pid];
      if (!data) return;
      window.ScProductSet.openPreviewModal({
        id: data.id,
        variant_id: data.variant_id,
        title: data.title,
        description: data.description || '',
        images: data.images || [],
        badgesHtml: data.badgesHtml || '',
        price: data.price || 0,
        compare_at_price: data.compare_at_price || 0,
      });
    });

    document.body.addEventListener('click', function (e) {
      const colorModal = scGetColorModal();

      const rm = e.target.closest('.sc-color-selection-wrapper .sc-remove-color');
      if (rm) {
        e.preventDefault();
        e.stopPropagation();
        const slot = rm.closest('.sc-color-slot');
        const pid = slot && slot.getAttribute('data-product-id');
        if (pid) {
          if (slot && slot.getAttribute('data-bonus') === 'true') {
            const bIndex = parseInt(slot.getAttribute('data-bonus-index') || '-1', 10);
            window.ScProductSet.removeBonusAt(bIndex);
          } else {
            window.ScProductSet.removeProduct(pid);
          }
          window.ScProductSet.transferToMainScreen();
        }
        return;
      }

      const colorSlot = e.target.closest('.sc-color-selection-wrapper .sc-color-slot');
      if (colorSlot) {
        e.preventDefault();
        e.stopPropagation();
        if (colorModal) {
          colorModal.setAttribute('aria-hidden', 'false');
          scSyncModalBodyScroll();
          // Force-hydrate after the modal becomes visible. IntersectionObserver
          // can miss the visibility transition (notably in IG/FB in-app browsers),
          // so we kick a hydration pass on the next frame to guarantee images appear.
          requestAnimationFrame(scHydrateAllCards);
        }
        return;
      }

      if (e.target.closest('#sc-color-modal [data-action="close"]')) {
        if (colorModal) {
          colorModal.setAttribute('aria-hidden', 'true');
          scSyncModalBodyScroll();
          scDehydrateAllCards();
        }
        return;
      }

      if (e.target.closest('#sc-nail-preview-modal [data-action="close-preview"]')) {
        const previewModal = document.getElementById('sc-nail-preview-modal');
        if (previewModal) {
          previewModal.setAttribute('aria-hidden', 'true');
          scSyncModalBodyScroll();
        }
        return;
      }

      // Direct X-icon deselect on a chosen footer thumbnail.
      const thumbRemoveBtn = e.target.closest('#sc-modal-thumbnails .sc-thumb-remove');
      if (thumbRemoveBtn && colorModal && colorModal.contains(thumbRemoveBtn)) {
        e.preventDefault();
        e.stopPropagation();
        const pidT = thumbRemoveBtn.getAttribute('data-product-id');
        if (pidT) {
          if (thumbRemoveBtn.getAttribute('data-bonus') === 'true') {
            const wrap = thumbRemoveBtn.closest('.sc-thumb-slot-wrap');
            const bIndex = parseInt(
              (wrap && wrap.getAttribute('data-bonus-index')) ||
                thumbRemoveBtn.getAttribute('data-bonus-index') ||
                '-1',
              10
            );
            window.ScProductSet.removeBonusAt(bIndex);
          } else {
            window.ScProductSet.removeProduct(pidT);
          }
          window.ScProductSet.transferToMainScreen();
        }
        return;
      }

      const filterTag = e.target.closest('#sc-color-modal .sc-filter-tag');
      if (filterTag) {
        const filterValue = filterTag.getAttribute('data-filter');
        const modal = scGetColorModal();
        modal.querySelectorAll('.sc-filter-tag').forEach((t) => t.classList.remove('active'));
        filterTag.classList.add('active');
        scApplyCollectionFilter(filterValue);
        // Filter may have revealed previously hidden (not-yet-hydrated) cards;
        // hydrate enough of them to fill the viewport on the next frame.
        requestAnimationFrame(function () {
          scHydrateNextBatch(SC_INITIAL_BATCH);
          scMaybeLoadMoreColorPages();
        });
        return;
      }

      const addTarget = e.target.closest('#sc-color-modal .sc-product-card-wrapper [data-action="add"]');
      if (addTarget) {
        const wrapper = addTarget.closest('.sc-product-card-wrapper');
        const pd = wrapper && scReadProductDataFromWrapper(wrapper);
        if (pd) {
          window.ScProductSet.addProduct(pd);
        }
        return;
      }

      const plusBtn = e.target.closest('#sc-color-modal .sc-qty-plus');
      if (plusBtn) {
        const wrapper = plusBtn.closest('.sc-product-card-wrapper');
        const pd = wrapper && scReadProductDataFromWrapper(wrapper);
        if (pd) {
          window.ScProductSet.addProduct(pd);
        }
        return;
      }

      const minusBtn = e.target.closest('#sc-color-modal .sc-qty-minus');
      if (minusBtn) {
        const wrapper = minusBtn.closest('.sc-product-card-wrapper');
        const card = wrapper && wrapper.querySelector('.sc-product-card');
        const pidM = card && card.getAttribute('data-product-id');
        if (pidM) {
          window.ScProductSet.removeProduct(pidM);
        }
        return;
      }

      const confirmBtn = e.target.closest('#sc-btn-confirm');
      if (confirmBtn) {
        // Schicht 6: prevent accidental form-submit / page-reload via bubbling.
        e.preventDefault();
        e.stopPropagation();
        if (confirmBtn.dataset.scBusy) return;
        confirmBtn.dataset.scBusy = '1';
        if (colorModal) {
          colorModal.setAttribute('aria-hidden', 'true');
          scSyncModalBodyScroll();
          // Free hydrated card images before allocating new ones on the main
          // screen — prevents OOM crashes in constrained mobile WebViews.
          scDehydrateAllCards();
        }
        requestAnimationFrame(function () {
          window.ScProductSet.transferToMainScreen();
          delete confirmBtn.dataset.scBusy;
        });
        return;
      }

      const atcBtn = e.target.closest('#sc-add-to-cart-button');
      if (atcBtn) {
        const baseCap = scGetBaseColorsCap();
        if (window.ScProductSet.getBaseQty() < baseCap) {
          e.preventDefault();
          if (colorModal) {
            colorModal.setAttribute('aria-hidden', 'false');
            scSyncModalBodyScroll();
            requestAnimationFrame(scHydrateAllCards);
          }
          return;
        }

        const formId = atcBtn.getAttribute('data-form-id');
        if (!formId) {
          return;
        }

        const form = document.getElementById(formId);
        if (!form) {
          return;
        }

        atcBtn.classList.add('sc-is-loading');
        atcBtn.disabled = true;

        form.querySelectorAll('.sc-dynamic-property').forEach((el) => el.remove());

        const bonusColors = window.ScProductSet.bonusProducts || [];

        let colorIndex = 1;
        let variantIds = [];
        window.ScProductSet.selectedProducts.forEach((prod) => {
          for (let i = 0; i < prod.qty; i++) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[Farbe ${colorIndex}]`;
            input.value = prod.title;
            input.className = 'sc-dynamic-property';
            form.appendChild(input);

            if (prod.variant_id != null && prod.variant_id !== '') {
              variantIds.push(prod.variant_id);
            }
            colorIndex++;
          }
        });

        if (variantIds.length > 0) {
          const idsInput = document.createElement('input');
          idsInput.type = 'hidden';
          idsInput.name = 'properties[_product_ids]';
          idsInput.value = variantIds.join(',');
          idsInput.className = 'sc-dynamic-property';
          form.appendChild(idsInput);
        }

        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.disabled = false;
        }

        const resetLoading = () => {
          atcBtn.classList.remove('sc-is-loading');
          if (window.ScProductSet.getBaseQty() >= baseCap) {
            atcBtn.disabled = false;
          }
        };

        const submitMainForm = () => {
          setTimeout(resetLoading, 1000);
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        };

        const scAddExtraItemsThenSubmit = function (items) {
          if (!items.length) {
            submitMainForm();
            return;
          }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items: items }),
          })
            .then(() => submitMainForm())
            .catch(() => submitMainForm());
        };

        const runAddFlow = function () {
          const extraItems = [];
          const giftInput = document.getElementById('sc-gift-box-variant-id');
          if (giftInput && giftInput.value) {
            extraItems.push({ id: parseInt(giftInput.value, 10), quantity: 1 });
          }
          if (bonusColors.length) {
            const discountPct = scGetActiveBonusDiscountPercent();
            bonusColors.forEach((bonusColor) => {
              if (bonusColor.variant_id != null && bonusColor.variant_id !== '') {
                extraItems.push({
                  id: parseInt(bonusColor.variant_id, 10),
                  quantity: 1,
                  properties: {
                    _sc_bonus_color: 'true',
                    _sc_bonus_discount: String(discountPct) + '%',
                    'Bonus Farbe': bonusColor.title,
                  },
                });
              }
            });
          }
          scAddExtraItemsThenSubmit(extraItems);
        };

        // Optional discount code for bonus colors (Shopify automatic code apply)
        const bonusCode = bonusColors.length ? scGetBonusDiscountCode() : '';
        if (bonusCode) {
          fetch('/discount/' + encodeURIComponent(bonusCode), {
            credentials: 'same-origin',
          })
            .then(() => runAddFlow())
            .catch(() => runAddFlow());
        } else {
          runAddFlow();
        }
        return;
      }

      const openSettings = e.target.closest('#sc-open-settings');
      if (openSettings && colorModal && colorModal.contains(openSettings)) {
        e.stopPropagation();
        const settingsModal = document.getElementById('sc-view-settings-modal');
        if (!settingsModal) {
          return;
        }
        const isHidden = settingsModal.getAttribute('aria-hidden') === 'true';
        if (isHidden) {
          settingsModal.setAttribute('aria-hidden', 'false');
          applyViewSettings(getCookie('sc_view_color') || 'product', getCookie('sc_view_grid') || 'small');
        } else {
          settingsModal.setAttribute('aria-hidden', 'true');
        }
        return;
      }

      const closeSettings = e.target.closest('[data-action="close-settings"]');
      if (closeSettings) {
        const settingsModal = document.getElementById('sc-view-settings-modal');
        if (settingsModal && settingsModal.contains(closeSettings)) {
          settingsModal.setAttribute('aria-hidden', 'true');
        }
        return;
      }

      const settingOpt = e.target.closest('#sc-view-settings-modal .sc-setting-option');
      if (settingOpt) {
        const group = settingOpt.getAttribute('data-setting-group');
        const val = settingOpt.getAttribute('data-setting-value');
        const currentColorView = getCookie('sc_view_color') || 'product';
        const currentGridView = getCookie('sc_view_grid') || 'small';
        if (group === 'color') {
          setCookie('sc_view_color', val, 30);
          applyViewSettings(val, currentGridView);
        } else if (group === 'grid') {
          setCookie('sc_view_grid', val, 30);
          applyViewSettings(currentColorView, val);
        }
      }
    });

    document.addEventListener('click', function (e) {
      const settingsModal = document.getElementById('sc-view-settings-modal');
      if (settingsModal && settingsModal.getAttribute('aria-hidden') === 'false' && !settingsModal.contains(e.target)) {
        settingsModal.setAttribute('aria-hidden', 'true');
      }
    });

    function scOnMainProductSectionReplaced() {
      window.ScProductSet.selectedProducts = [];
      window.ScProductSet.bonusProducts = [];
      window.ScProductSet.lastSelectedColorTitle = null;
      window.ScProductSet._previousSelectedState = new Map();
      scProductsData = null; // re-parse on next access
      scPortalizeModal();
      scInitCarouselDelegation();
      scSetupHydrateObserver();
      applyViewSettings(getCookie('sc_view_color') || 'product', getCookie('sc_view_grid') || 'small');
      window.ScProductSet.renderModalState();
      window.ScProductSet.transferToMainScreen();
      scSyncModalBodyScroll();
    }

    document.addEventListener('sc:main-product-section-replaced', scOnMainProductSectionReplaced);

    // === Schicht 6: portal modal to body so it cannot bubble to a parent <form> ===
    function scPortalizeModal() {
      const modal = scGetColorModal();
      if (!modal) return;
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    }

    scPortalizeModal();
    scInitCarouselDelegation();
    scSetupHydrateObserver();
    applyViewSettings(getCookie('sc_view_color') || 'product', getCookie('sc_view_grid') || 'small');
    scUpdateDiscountBadges([]);
    scUpdateProductMetaPrice([]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scInit);
    } else {
      scInit();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
